import moment from "moment";

/** Asia/Kolkata is a fixed +05:30 and has no DST, so an offset is enough. */
export const IST_OFFSET_MINUTES = 330;

const ZONE_SUFFIX = /(?:Z|[+-]\d{2}:?\d{2})$/i;

/** "Now" in Indian time, for day comparisons. */
export const istNow = () => moment().utcOffset(IST_OFFSET_MINUTES);

/**
 * Convert a backend timestamp to Indian time, whatever zone the device is in.
 *
 * Every timestamp this backend produces is UTC. The REST APIs say so
 * explicitly (`2026-08-12T13:34:29.000Z`), but the socket gateway emits the
 * value TypeORM leaves on a saved entity, which is a UTC datetime string with
 * no zone designator (`2026-08-12 19:12:34`). Those are parsed as UTC rather
 * than as the device's zone, so both forms land on the same instant.
 *
 * @return {moment.Moment|null} null when the value is missing or unparseable
 */
export const toIst = (value) => {
  if (value === null || value === undefined || value === "") return null;

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!ZONE_SUFFIX.test(trimmed)) {
      const parsed = moment.utc(
        trimmed.replace(" ", "T"),
        moment.ISO_8601,
        true,
      );
      return parsed.isValid() ? parsed.utcOffset(IST_OFFSET_MINUTES) : null;
    }
  }

  const date = moment(value);
  return date.isValid() ? date.utcOffset(IST_OFFSET_MINUTES) : null;
};
